import React from 'react';
import { DateType } from '../../types';
import type { TimeSeriesDataPoint } from '../../types/time-series.types';
import { TrendCard } from '../trend-card';

interface EngagementTrendsCardProps {
  hasData?: boolean;
  dateType?: DateType;
  timeSeriesData?: TimeSeriesDataPoint[];
}

const EngagementTrendsCard: React.FC<EngagementTrendsCardProps> = ({
  hasData = true,
  dateType = 'last6Months',
  timeSeriesData = []
}) => {
  const colors = {
    Instagram: '#db2777', // pink-600
    TikTok: '#f472b6', // pink-400
    YouTube: '#fbcfe8', // pink-200
    Pinterest: '#fce7f3', // pink-100
  };

  return (
    <TrendCard
      title="Engagement"
      hasData={hasData}
      dateType={dateType}
      timeSeriesData={timeSeriesData}
      colors={colors}
      emptyStateTitle="No engagement data available."
      emptyStateDescription="Engagement trends will appear here once data is available."
    />
  );
};

export default EngagementTrendsCard;
